import React from "react";
import ErrorFallback from './ErrorFallback';
import { isSupabaseError } from '../utils/supabaseHealthCheck';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    error.__ErrorBoundary = true;
    
    this.setState({ errorInfo });
    
    window.__COMPONENT_ERROR__?.(error, errorInfo);
    
    console.error('Error Boundary caught an error:', {
      error,
      errorInfo,
      isSupabaseError: isSupabaseError(error),
      timestamp: new Date()?.toISOString()
    });
  }

  resetError = () => {
    this.setState({ 
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state?.hasError) {
      return (
        <ErrorFallback 
          error={this.state?.error}
          errorInfo={this.state?.errorInfo}
          resetError={this.resetError}
        />
      );
    }

    return this.props?.children;
  }
}

export default ErrorBoundary;